module.exports = __webpack_public_path__ + "static/slide-1a-26721c150df0e3d8d4a2515ffdae0355.jpg";